import type { LocationQueryValue } from "vue-router";

/** Undefined for repeated values: we can't handle multiple values. */
export function parseStringOrUndefined(
  value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
  if (value === null || typeof value !== "string") {
    return undefined;
  }

  return value;
}

export function parseLocationQueryStringArray(value: LocationQueryValue | LocationQueryValue[] | undefined): string[] {
  if (value == null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter((entry): entry is string => typeof entry === "string");
  }
  return typeof value === "string" ? [value] : [];
}

export function parseLocationQueryValueInt(
  value: LocationQueryValue | LocationQueryValue[] | undefined,
  defaultValue: number,
) {
  if (value == null || typeof value !== "string") {
    return defaultValue;
  }

  const parsingResult = parseInt(value, 10);
  if (!isNaN(parsingResult)) {
    return parsingResult;
  }
  return defaultValue;
}
